import React from 'react';
import { useShipmentLedgers } from 'utils/hooks/useShipmentLedgers';
import JobList from 'components/modules/accounting/JobList';
function buildPaidLineItems(invoice) {
    var _a;
    return ((_a = invoice.lineItemGroups) !== null && _a !== void 0 ? _a : []).map((job) => ({
        _id: job.shipment_id,
        receivables: job.lineItems.map((lineItem) => (Object.assign(Object.assign({}, lineItem), { invoice_id: invoice._id }))),
    }));
}
function buildOrderLevelLineItems(invoice) {
    var _a;
    return ((_a = invoice.lineItemGroups) !== null && _a !== void 0 ? _a : [])
        .filter((group) => !group.shipment_id)
        .map((group) => ({
        _id: null,
        receivables: group.lineItems.map((lineItem) => (Object.assign(Object.assign({}, lineItem), { invoice_id: invoice._id }))),
    }));
}
export default function InvoiceJobList({ invoice }) {
    var _a, _b;
    const jobIds = ((_a = invoice.jobs) !== null && _a !== void 0 ? _a : []).map((job) => typeof job === 'string' ? job : job._id);
    const isPaid = invoice.status === 'paid';
    const hasJobs = jobIds.length > 0;
    const { data: ledgerItems, isLoading, isError, } = useShipmentLedgers(jobIds, 'invoice', {
        enabled: !isPaid && hasJobs,
    });
    const lineItems = isPaid
        ? buildPaidLineItems(invoice)
        : [...(ledgerItems !== null && ledgerItems !== void 0 ? ledgerItems : []), ...buildOrderLevelLineItems(invoice)];
    return (React.createElement(JobList, { context: "invoice", ledgerType: invoice.type, ledgerId: invoice._id, jobs: (_b = invoice.lineItemGroups) !== null && _b !== void 0 ? _b : [], lineItems: lineItems, isLoading: !isPaid && hasJobs && isLoading, isError: !isPaid && isError }));
}
